import { Link } from "react-router-dom";
import "./projects.css";

function Projects() {
  const projects = [
    {
      title: "CC Training Dashboard",
      previewImage: "/stravaCover.png",
      description: "Cycling performance dashboard with Strava API integration to analyze power curves and training volume.",
      technologies: ["TypeScript", "React", "Tailwind CSS", "Strava API", "Recharts", "Vercel"],
      repoLink: "https://github.com/charliecarroll222/cc-training-dashboard",
      liveLink: "https://cc-training-dashboard.vercel.app"
    },
    {
      title: "ProCamGo E-Commerce Store",
      previewImage: "/proCamCover.png",
      description: "Full Shopify storefront for a camera accessories brand, built with custom Liquid templates, SEO/SEM optimization, and Google Ads integration.",
      technologies: ["Shopify", "Liquid", "JavaScript", "HTML/CSS", "SEO/SEM", "Google Ads/Analytics"],
      repoLink: "https://procamgo.com"
    },
    {
      title: "Theta Chi Cycling App",
      previewImage: "/cycling1.jpeg",
      technologies: ["Swift", "Firebase Auth", "Firestore DB", "MapKit", "Xcode"],
      repoLink: "https://github.com/charliecarroll222/projects/tree/main/OΧ%20Cycling"
    },
    {
      title: "My Personal Site",
      previewImage: "/websiteCover.png",
      technologies: ["JavaScript", "CSS", "React", "Firebase Hosting"],
      repoLink: "https://github.com/charliecarroll222/cjc-portfolio"
    },
    {
      title: "Outlook Email Sorter",
      previewImage: "/outlook1.png",
      technologies: ["Python", "Azure", "REST API"],
    },
    {
      title: "iOS Casino Game",
      previewImage: "/casino.jpg",
      technologies: ["Swift", "Xcode", "Persistent Storage", "AVFoundation"],
      repoLink: "https://github.com/charliecarroll222/projects/tree/main/CasinoGame"
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <span className="hero-eyebrow">Software Engineer · IU Luddy &rsquo;26</span>
          <h1 className="hero-name">Charlie Carroll</h1>
          <p className="hero-subtitle">
            CS with Software Engineering specialization · Building clean web &amp; iOS experiences
          </p>
          <div className="hero-actions">
            <a href="#projects" className="btn-primary">View My Work</a>
            <Link to="/contact" className="btn-outline">Get in Touch</Link>
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <div id="projects" className="project-container">
        <h2 className="section-title">Projects</h2>
        <div className="grid">
          {projects.map((project, index) => {
            const hasButtons = !!project.liveLink;

            const card = (
              <div className={`project-box${hasButtons ? ' has-buttons' : ''}`}>
                <img
                  src={project.previewImage}
                  alt={`${project.title} preview`}
                  className="project-preview"
                />
                <div className="project-info">
                  <h3 className="project-title">{project.title}</h3>
                  {project.description && (
                    <p className="project-description">{project.description}</p>
                  )}
                  {!project.repoLink && !project.liveLink && (
                    <span className="private-badge">Private Repo</span>
                  )}
                  <ul className="tech-list">
                    {project.technologies.map((tech, i) => (
                      <li key={i}>{tech}</li>
                    ))}
                  </ul>
                  {hasButtons && (
                    <div className="project-links">
                      <a href={project.liveLink} target="_blank" rel="noopener noreferrer" className="project-btn">
                        Live Demo
                      </a>
                      {project.repoLink && (
                        <a href={project.repoLink} target="_blank" rel="noopener noreferrer" className="project-btn-outline">
                          GitHub
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </div>
            );

            if (hasButtons) {
              return <div key={index} className="project-link">{card}</div>;
            }

            return project.repoLink ? (
              <a
                key={index}
                href={project.repoLink}
                target="_blank"
                rel="noopener noreferrer"
                className="project-link"
              >
                {card}
              </a>
            ) : (
              <div key={index} className="project-link no-link">
                {card}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Projects;
